export class LiveSignal {
    data: SignalData;
    latestPrice: PriceData;
    key: string;
    constructor(data: SignalData) {
        if (data) {
            this.data = data;
            if (!this.data.stops) this.data.stops = [];
            if (!this.data.targets) this.data.targets = [];
            if (!this.data.close) this.data.close = null;
            if (!this.data.spot) this.data.spot = 0;
            if (!this.data.message) this.data.message = '';
        } else {
            this.data = getBlankSignalData();
        }
        this.latestPrice = this.getLatestPrice();
    }

    public isActive(): boolean {
        return this.data.isActive;
    }

    public getStatusText(): string {
        if (this.isActive()) {
            return 'Open';
        } else {
            return 'Closed';
        }
    }

    public setClosePrice(price: number) {
        this.data.close = {
            price: price,
            timestamp: (new Date()).getTime().toString(),
            message: null,
            isActive: true
        };
        this.latestPrice = this.getLatestPrice();
    }
    
    public addTarget(price: number) {
        this.data.targets.push({
            price: price,
            timestamp: null,
            message: null,
            isActive: true
        })
        //Sort
    }

    public removeTarget(price: PriceData) {
        const index = this.data.targets.indexOf(price);
        if (index > -1) {
            this.data.targets.splice(index, 1);
        }
    }

    public editTarget(price: PriceData) {
        let index = this.data.targets.indexOf(price);
        if (index > -1) {
            this.data.targets[index] = price;
            this.latestPrice = this.getLatestPrice();
        }
    }

    public addStop(price: number) {
        for (let stop of this.data.stops) {
            stop.isActive = false;
            //Include a stop message here
        }
        this.data.stops.push({
            price: price,
            timestamp: null,
            message: null,
            isActive: true
        })
        //Sort
    }

    public removeStop(price: PriceData) {
        const index = this.data.stops.indexOf(price);
        if (index > -1) {
            this.data.stops.splice(index, 1);
        }
    }

    public editStop(price: PriceData) {
        let index = this.data.stops.indexOf(price);
        if (index > -1) {
            this.data.stops[index] = price;
            this.latestPrice = this.getLatestPrice();
        }
    }

    public getPercentGain(price: PriceData): number {
        return (price.price - this.data.spot) / this.data.spot * 100;
    }

    public getCurrentPercentGain(): number {
        if (this.latestPrice) {
            return this.getPercentGain(this.latestPrice);
        } else {
            return 0;
        }
    }

    //Returns the highest target hit or the stop loss.
    public getLatestPrice(): PriceData {
        let latestPrice: PriceData;

        //Always use close as the latest price
        if (this.data.close) {
            return this.data.close;
        }

        //Get latest target for which there is a timestamp
        let hitTargets = this.getHitTargets();
        for (let target of hitTargets) {
            if (!latestPrice) {
                latestPrice = target;
            } else if (parseInt(target.timestamp) > parseInt(latestPrice.timestamp)) {
                latestPrice = target;
            }
        }

        if (latestPrice) {
            return latestPrice;
        } else {
            if (this.data.stops.length >= 1) {
                let stop = this.data.stops[0];
                if (stop.timestamp) {
                    latestPrice = stop;
                } else {
                    latestPrice = null;
                }
            }
            return latestPrice;
        }
    }

    public getHitTargets(): PriceData[] {
        let targets = this.data.targets.filter(x => x.timestamp != null);
        return targets;
    }
}

function getBlankSignalData(): SignalData {
    return {
        coin: null,
        spot: null,
        message: '',
        timestamp: null,
        isActive: true,
        stops: [],
        targets: []
    }
}

export interface SignalData {
    coin: string;
    fullName?: string;
    isStock?: boolean;
    spot: number;
    message: string;
    timestamp: string;
    isActive: boolean;
    stops: PriceData[];
    targets: PriceData[];
    close?: PriceData;
    high?: PriceData;
    low?: PriceData;
}

export interface PriceData {
    price: number;
    timestamp: string;
    message: string;
    isActive: boolean;
}



// WEBPACK FOOTER //
// ./src/models/Signal.ts